import { fetchApi } from '@/common-utilities/fetch-utilities';
import { API_ENDPOINTS } from '@/common-constants/api-constants';
import type { TransactionByIdResponse } from '@/common-types';

/**
 * Get transaction details by ID from Log Oracle API
 */
export async function getTransactionById(
  transactionId: string
): Promise<TransactionByIdResponse['data']> {
  const endpoint = API_ENDPOINTS.TRANSACTION_BY_ID(transactionId);
  const response = await fetchApi<TransactionByIdResponse>(endpoint);
  return response.data?.data ?? response.data;
}

export default {
  getTransactionById,
};
